// extracted by mini-css-extract-plugin
export default {"customTable":"style_customTable__mw9Im","showMore":"style_showMore__yFXwY"};